
    import {defineComponent, reactive, toRefs} from 'vue'
    import swiperComponent from "@/views/h5/_components/swiperCommon.vue";

    interface State {
        photoList: Array<any>;
    }

    export default defineComponent({
        name: "bannerModel",
        props: {
            photoList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                photoList: [],
            })
            const {photoList} = toRefs(props);
            state.photoList = photoList.value
            return {
                state
            }
        },
        methods:{
            closeModel(){
                this.$emit('closeModel')
            }
        },
        components: {
            swiperComponent
        }
    })
